import React, { useState } from "react";
import ExpenseManagement from '../ExpenseManagement/Expensemanagementdata';
import Settings from '../Settings/Settings';
import Clients from '../CustomerManagement/Customermanagementdata';
import InvoiceManagement from '../Billing/Invoicedata';
import TaxReturns from '../TaxManagement/TaxReturns';
import Reporting from '../Reporting/Reportingdata';
import Overview from '../Dashboard/Overviewdata';
import ProductManagement from '../Inventory/Productdata'; // ← new import

let useNavigate;
try { useNavigate = require("react-router-dom").useNavigate; }
catch { useNavigate = () => (path) => { window.location.href = path; }; }

const GlobalStyles = () => (
  <style>{`
    @import url('https://fonts.googleapis.com/css2?family=Playfair+Display:wght@600;700;800&family=DM+Sans:wght@300;400;500;600&family=DM+Mono:wght@400;500&display=swap');

    *, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }
    html, body { height: 100%; overflow: hidden; }
    body {
      font-family: 'DM Sans', system-ui, sans-serif;
      color: #1a1a2e;
      background: #f8fafc;
    }
    button { font-family: inherit; cursor: pointer; }

    :root {
      --blue: #4f8ef7;
      --blue-light: #eff6ff;
      --ink: #1a1a2e;
      --ink-muted: #555;
      --ink-faint: #888;
      --surface: #ffffff;
      --bg: #f8fafc;
      --border: #f0f0f0;
      --border-s: #f5f5f5;
      --green: #52c97e;
      --coral: #f97b6b;
      --purple: #a78bfa;
      --sb: #13131f;
      --sb-hover: #1e1e30;
      --sb-border: rgba(255,255,255,.07);
      --sb-text: rgba(255,255,255,.45);
      --rl: 14px;
    }

    @keyframes pulseDot {
      0%, 100% { box-shadow: 0 0 0 0 rgba(82,201,126,0.5); }
      50%       { box-shadow: 0 0 0 8px rgba(82,201,126,0); }
    }
    @keyframes slideIn {
      from { transform: translateX(40px); opacity: 0; }
      to   { transform: translateX(0); opacity: 1; }
    }

    .ic-shell { display: flex; height: 100vh; width: 100vw; overflow: hidden; }

    .ic-sidebar {
      width: 230px; min-width: 230px; background: var(--sb); display: flex; flex-direction: column;
      height: 100vh; overflow: hidden; position: relative; flex-shrink: 0;
    }
    .ic-sidebar::before {
      content: ''; position: absolute; width: 260px; height: 260px; border-radius: 50%;
      background: #4f8ef7; filter: blur(90px); opacity: .07; top: -80px; right: -80px; pointer-events: none; z-index: 0;
    }

    .ic-logo-wrap {
      padding: 24px 18px 20px; border-bottom: 1px solid var(--sb-border);
      position: relative; z-index: 2; flex-shrink: 0;
    }
    .ic-logo-row { display: flex; align-items: center; gap: 9px; cursor: pointer; margin-bottom: 2px; }
    .ic-logo-icon {
      width: 32px; height: 32px; background: linear-gradient(135deg, var(--blue), #6366f1);
      border-radius: 8px; display: flex; align-items: center; justify-content: center;
      font-size: 14px; flex-shrink: 0;
    }
    .ic-logo-name { font-family: 'Playfair Display', serif; font-weight: 700; font-size: 18px; color: #fff; line-height: 1; }
    .ic-logo-name span { color: var(--blue); }
    .ic-logo-sub { font-size: 10px; font-weight: 600; letter-spacing: 1.4px; color: var(--blue); text-transform: uppercase; margin-left: 41px; margin-top: 2px; }

    .ic-nav {
      flex: 1; padding: 10px 10px; display: flex; flex-direction: column; gap: 1px;
      position: relative; z-index: 2; overflow-y: auto; overflow-x: hidden;
    }
    .ic-nav::-webkit-scrollbar { width: 3px; }
    .ic-nav::-webkit-scrollbar-thumb { background: rgba(255,255,255,.08); border-radius: 2px; }

    .ic-nav-lbl {
      font-size: 10px; font-weight: 700; letter-spacing: 1.3px; text-transform: uppercase;
      color: rgba(255,255,255,.2); padding: 12px 10px 5px;
    }
    .ic-nav-item {
      display: flex; align-items: center; gap: 10px; padding: 8px 11px; border-radius: 9px;
      font-size: 13px; font-weight: 500; color: var(--sb-text);
      transition: all .15s; border: 1px solid transparent;
      background: none; text-align: left; width: 100%;
      font-family: 'DM Sans', sans-serif; flex-shrink: 0;
    }
    .ic-nav-item:hover { background: var(--sb-hover); color: rgba(255,255,255,.85); }
    .ic-nav-item.active {
      background: rgba(79,142,247,.13); color: var(--blue); font-weight: 600; border-color: rgba(79,142,247,.22);
    }
    .ic-nav-icon { font-size: 15px; width: 18px; text-align: center; flex-shrink: 0; }

    .ic-sb-footer { padding: 12px 10px; border-top: 1px solid var(--sb-border); position: relative; z-index: 2; flex-shrink: 0; }
    .ic-user-row {
      display: flex; align-items: center; gap: 9px; padding: 9px 11px;
      border-radius: 9px; background: rgba(255,255,255,.05); margin-bottom: 7px;
    }
    .ic-user-av {
      width: 28px; height: 28px; border-radius: 7px; background: linear-gradient(135deg, var(--blue), #6366f1);
      color: #fff; display: flex; align-items: center; justify-content: center; font-size: 11px; font-weight: 700; flex-shrink: 0;
    }
    .ic-user-name { font-size: 12px; font-weight: 600; color: #fff; }
    .ic-user-role { font-size: 10px; color: rgba(255,255,255,.3); margin-top: 1px; }
    .ic-logout-btn {
      display: flex; align-items: center; gap: 7px; width: 100%; padding: 8px 11px;
      background: none; border: 1px solid rgba(255,255,255,.08); border-radius: 9px;
      color: rgba(255,255,255,.35); cursor: pointer; font-size: 12px; font-family: 'DM Sans', sans-serif; transition: all .15s;
    }
    .ic-logout-btn:hover { border-color: rgba(249,123,107,.5); color: var(--coral); background: rgba(249,123,107,.07); }

    .ic-main { flex: 1; display: flex; flex-direction: column; height: 100vh; overflow: hidden; min-width: 0; }
    .ic-topbar {
      background: var(--surface); border-bottom: 1px solid var(--border);
      padding: 14px 26px; display: flex; align-items: center; justify-content: space-between; flex-shrink: 0;
    }
    .ic-topbar-title { font-family: 'Playfair Display', serif; font-size: 17px; font-weight: 800; color: var(--ink); }
    .ic-topbar-date { font-size: 11px; color: var(--ink-faint); margin-top: 2px; }
    .ic-topbar-badge {
      display: flex; align-items: center; gap: 8px; background: rgba(79,142,247,.08);
      border: 1px solid rgba(79,142,247,.2); padding: 6px 14px; border-radius: 20px;
      font-size: 12px; font-weight: 600; color: var(--blue);
    }
    .adot { width: 7px; height: 7px; background: var(--green); border-radius: 50%; animation: pulseDot 2s infinite; }

    .ic-content { flex: 1; overflow-y: auto; overflow-x: hidden; padding: 22px 26px; }
    .ic-content::-webkit-scrollbar { width: 5px; }
    .ic-content::-webkit-scrollbar-thumb { background: #e0e0e0; border-radius: 3px; }

    .ic-empty { display: flex; flex-direction: column; align-items: center; justify-content: center; height: 100%; min-height: 300px; color: var(--ink-faint); text-align: center; gap: 10px; }
    .ic-empty-icon { font-size: 40px; opacity: .25; }
    .ic-empty-title { font-family: 'Playfair Display', serif; font-size: 16px; font-weight: 700; color: #ccc; }
    .ic-empty-sub { font-size: 13px; color: #ddd; }
  `}</style>
);

const NAV_ITEMS = [
  { id: "overview",  label: "Overview",  icon: "⊞" },
  { id: "invoices",  label: "Invoices",  icon: "🗒" },
  { id: "clients",   label: "Clients",   icon: "👥" },
  { id: "products",  label: "Products",  icon: "📦", section: "Finance" }, // ← new nav item
  { id: "expenses",  label: "Expenses",  icon: "📊" },
  { id: "tax",       label: "Tax Returns", icon: "🍁" },
  { id: "reports",   label: "Reports",   icon: "📁" },
  { id: "settings",  label: "Settings",  icon: "⚙",  section: "Account" },
];

const today = new Date().toLocaleDateString("en-CA", {
  weekday: "long", year: "numeric", month: "long", day: "numeric",
});

export default function Dashboard({ onLogout }) {
  const navigate = useNavigate();
  const [tab, setTab] = useState("overview");

  const navWithSections = [];
  NAV_ITEMS.forEach((item) => {
    if (item.section) navWithSections.push({ type: "section", label: item.section });
    navWithSections.push({ type: "item", ...item });
  });

  const currentLabel = NAV_ITEMS.find(n => n.id === tab)?.label || "Overview";

  const renderContent = () => {
    switch (tab) {
      case "overview":
        return <Overview />;
      case "invoices":
        return <InvoiceManagement />;
      case "products":
        return <ProductManagement />; // ← new case
      case "expenses":
        return <ExpenseManagement />;
      case "clients":
        return <Clients />;
      case "settings":
        return <Settings />;
      case "tax":
        return <TaxReturns />;
      case "reports":
        return <Reporting />;
      default:
        return (
          <div className="ic-empty">
            <div className="ic-empty-icon">
              {NAV_ITEMS.find(n => n.id === tab)?.icon || "⊞"}
            </div>
            <div className="ic-empty-title">{currentLabel}</div>
            <div className="ic-empty-sub">Connect your backend API to load data here.</div>
          </div>
        );
    }
  };

  return (
    <>
      <GlobalStyles />
      <div className="ic-shell">
        <aside className="ic-sidebar">
          <div className="ic-logo-wrap">
            <div className="ic-logo-row" onClick={() => navigate("/")}>
              <div className="ic-logo-icon">🍁</div>
              <div className="ic-logo-name">Invoice<span>Cloud</span></div>
            </div>
            <div className="ic-logo-sub">Canada</div>
          </div>

          <nav className="ic-nav">
            {navWithSections.map((item, i) =>
              item.type === "section" ? (
                <div key={`sec-${i}`} className="ic-nav-lbl">{item.label}</div>
              ) : (
                <button
                  key={item.id}
                  className={`ic-nav-item${tab === item.id ? " active" : ""}`}
                  onClick={() => setTab(item.id)}
                >
                  <span className="ic-nav-icon">{item.icon}</span>
                  {item.label}
                </button>
              )
            )}
          </nav>

          <div className="ic-sb-footer">
            <div className="ic-user-row">
              <div className="ic-user-av">A</div>
              <div>
                <div className="ic-user-name">Admin</div>
                <div className="ic-user-role">InvoiceCloud Canada</div>
              </div>
            </div>
            <button className="ic-logout-btn" onClick={onLogout || (() => navigate("/login"))}>
              ↩ Sign Out
            </button>
          </div>
        </aside>

        <div className="ic-main">
          <header className="ic-topbar">
            <div>
              <div className="ic-topbar-title">{currentLabel}</div>
              <div className="ic-topbar-date">{today}</div>
            </div>
            <div className="ic-topbar-badge">
              <span className="adot" /> Active
            </div>
          </header>

          <main className="ic-content">
            {renderContent()}
          </main>
        </div>
      </div>
    </>
  );
}